import AppLayout from '@components/layouts/appLayout';

import StoryImage from '../components/Image';
import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer as RendererType, Tester } from '../types';

export const Renderer: RendererType = ({ story, storyPage }) => {
    return (
        <AppLayout
            footerPosition='absolute'
            headerPosition='absolute'
            footerHasPointerEvents={false}
            header={
                <StoryHeader
                    withExit={false}
                    story={story}
                    storyPage={storyPage}
                />
            }
            body={
                <StoryWrapper>
                    <StoryImage storyPage={storyPage} />
                </StoryWrapper>
            }
            footer={
                <StoryFooter
                    withNavigationButtons
                    storyPage={storyPage}
                    withCtas={false}
                    withVideoPlayerButtons={false}
                />
            }
        />
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Flow &&
            storyPage.type === StoryPageType.Image,
        priority: 4,
    };
};

const rendererWithTester = { renderer: Renderer, tester };

export default rendererWithTester;
